export const BLIK0_SUPPORTED_BANKS = [
  {
    iconUrl: '/images/common/blik/sgb.svg',
    name: 'SGB Bank S.A.'
  },
  {
    iconUrl: '/images/common/blik/pko.svg',
    name: 'PKO Bank Polski'
  }
]
